export default "__VITE_ASSET__36cfe85c__"